import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useBreadcrumb } from "../../../context/breadcrumb";
import { BreadcrumbActionType } from "../../../context/breadcrumb/reducer";
import VuiHelmet from "../../../components/helmet";
import RoleFormModule from "../../../modules/role/form";

const RoleFormPage = () => {
  const { t } = useTranslation();
  const { dispatch } = useBreadcrumb();
  const { id } = useParams();
  const metaTitle = id
    ? t("pages.role.detail.metaTitle")
    : t("pages.role.add.metaTitle");

  useEffect(() => {
    dispatch({
      type: BreadcrumbActionType.Update,
      payload: [
        {
          link: "/",
          title: t("common.text.home"),
        },
        {
          link: "/role",
          title: t("common.text.role"),
        },
        {
          link: `/role/${id || "add"}`,
          title: id ? t("common.text.detail") : t("common.text.add"),
          isDisabled: true,
        },
      ],
    });
  }, [dispatch, t, id]);

  return (
    <>
      <VuiHelmet title={metaTitle} />

      <RoleFormModule />
    </>
  );
};

export default RoleFormPage;
